module.exports = __webpack_public_path__ + "img/auth-bg.b799277d.jpg";